module.exports = "/images/Create your submittal log - 5.jpg";